module.exports = __webpack_public_path__ + "img/picto3.6948516a.svg";